import { HandledApplicationError } from '../../..'
import { isRedirectError } from 'next/dist/client/components/redirect-error'

export const rethrowErrors = (error: any) => {
    if (error instanceof HandledApplicationError) {
        throw error
    }
    // TODO: when upgraded to next 16, this may not work like this anymore. Need to verify.
    if (isRedirectError(error)) throw error
}
